(function () {
  'use strict';

  var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var legacyKeys = ['fulfillment_method', 'fulfillment_zip', 'pickup_location_name', 'pickup_location_id', 'local_delivery_verified', 'fulfillment_confirmed_at'];
  var cleanupStarted = false;

  function addGuidance() {
    var footer = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="footer"]');
    if (!footer || footer.querySelector('[data-wtpb-checkout-guidance]')) return;
    var section = document.createElement('section');
    section.className = 'wtpb-fulfillment';
    section.setAttribute('data-wtpb-checkout-guidance', '');
    section.setAttribute('aria-labelledby', 'wtpb-checkout-guidance-title');
    var title = document.createElement('h3');
    title.id = 'wtpb-checkout-guidance-title';
    title.className = 'wtpb-fulfillment__title';
    title.textContent = 'Choose delivery or pickup at checkout';
    var detail = document.createElement('p');
    detail.className = 'wtpb-fulfillment__helper';
    detail.textContent = 'For free route pickup, select Pickup in the checkout delivery section, then choose your pickup location. Check the selected store before paying, including in Shop Pay.';
    var link = document.createElement('a');
    link.href = rootPath + 'pages/delivery-routes';
    link.textContent = 'View pickup locations and route dates';
    var rates = document.createElement('p');
    rates.className = 'wtpb-fulfillment__helper';
    rates.textContent = 'Shipping and eligible local delivery rates are shown at checkout.';
    section.appendChild(title);
    section.appendChild(detail);
    section.appendChild(link);
    section.appendChild(rates);
    footer.insertBefore(section, footer.firstChild);
  }

  function clearLegacyPreferences() {
    if (cleanupStarted) return;
    cleanupStarted = true;
    fetch(rootPath + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var attributes = {};
        legacyKeys.forEach(function (key) {
          if (cart.attributes && cart.attributes[key]) attributes[key] = '';
        });
        if (!Object.keys(attributes).length) return;
        return fetch(rootPath + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart preference cleanup failed');
        });
      })
      .catch(function () { cleanupStarted = false; });
  }

  function init() {
    addGuidance();
    clearLegacyPreferences();
    new MutationObserver(addGuidance).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', function () {
      addGuidance();
      clearLegacyPreferences();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
